
(function () {
  "use strict";

  const POPUP_COMPONENT = "popup-component";
  const POPUP_CLOSE = "[data-popup-close]";
  const NOTIFICATION_FORM = "[data-notification-form]";
  const NOTIFICATION_HEADING = "[data-product-notification-heading]";
  const VARIANT_TITLE = "[data-variant-title]";
  const NOTIFICATION_PRODUCT = "[data-notification-product]";
  const PRODUCT_VARIANTS = "[data-product-variants]";

  const SUCCESS_CLASS = "has-success";
  const HIDDEN_CLASS = "hidden";

  if (customElements.get("product-notification")) return;

  customElements.define(
    "product-notification",
    class extends HTMLElement {
      constructor() {
        super();

        this.notificationForm = this.querySelector(NOTIFICATION_FORM);
        this.variantTitle = this.querySelector(VARIANT_TITLE);
        this.notificationProduct = this.querySelector(NOTIFICATION_PRODUCT);

        this.preventSubmit = true;

        this.popup = this.closest("dialog");
        this.popupClose = this.popup?.querySelector(POPUP_CLOSE);

        const variantsJSON = this.querySelector(PRODUCT_VARIANTS);

        this.variants = variantsJSON
          ? JSON.parse(variantsJSON.textContent)
          : [];

        /*
         * Store original notification form base ID.
         *
         * Example:
         * NotificationForm--template--123__main--456789
         *
         * becomes:
         * NotificationForm--template--123__main
         */
        this.notificationFormBaseId = "";

        if (this.notificationForm?.id) {
          const lastSeparator =
            this.notificationForm.id.lastIndexOf("--");

          if (lastSeparator !== -1) {
            this.notificationFormBaseId =
              this.notificationForm.id.substring(
                0,
                lastSeparator
              );
          }
        }

        this.productSection = this.getProductSection();
      }

      connectedCallback() {
        this.checkState();

        this.notificationForm?.addEventListener(
          "submit",
          (event) => {
            this.notificationSubmitEvent(event);
          }
        );

        this.popupClose?.addEventListener("click", () => {
          this.removeStorage();
        });

        /*
         * Most important:
         * when popup component is created/opened,
         * read the variant that the product form currently has.
         */
        this.updateCurrentVariant();

        /*
         * Update after variant option changes.
         *
         * We don't use event.target.value to determine
         * the variant. We allow the theme to finish its
         * own variant handling, then read the variant ID
         * from the product form.
         */
        document.addEventListener("change", (event) => {
          if (
            event.target.matches(
              'select[name^="options"], input[name^="options"]'
            )
          ) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                this.updateCurrentVariant();
              }, 0);
            });
          }
        });

        /*
         * Also watch the dialog opening.
         *
         * This is important because by this point the
         * theme has definitely selected the new variant.
         */
        if (this.popup) {
          this.popupObserver = new MutationObserver(() => {
            if (
              this.popup.open ||
              this.popup.hasAttribute("open")
            ) {
              this.updateCurrentVariant();
            }
          });

          this.popupObserver.observe(this.popup, {
            attributes: true,
            attributeFilter: ["open"]
          });
        }
      }

      getProductSection() {
        /*
         * Get section ID from:
         *
         * NotificationForm--SECTION-ID--VARIANT-ID
         */
        if (this.notificationForm?.id) {
          const prefix = "NotificationForm--";

          if (
            this.notificationForm.id.startsWith(prefix)
          ) {
            const value =
              this.notificationForm.id.substring(
                prefix.length
              );

            const lastSeparator =
              value.lastIndexOf("--");

            if (lastSeparator !== -1) {
              const sectionId = value.substring(
                0,
                lastSeparator
              );

              const section =
                document.getElementById(
                  "shopify-section-" + sectionId
                );

              if (section) {
                return section;
              }
            }
          }
        }

        /*
         * Fallback
         */
        return (
          this.closest(".shopify-section") ||
          document.querySelector(
            ".shopify-section [data-product]"
          ) ||
          document
        );
      }

      getCurrentVariantId() {
        const section =
          this.productSection || document;

        /*
         * Try theme product form first.
         */
        let variantInput =
          section.querySelector(
            '[data-product-form] [name="id"]'
          );

        /*
         * Standard Shopify product form fallback.
         */
        if (!variantInput) {
          variantInput =
            section.querySelector(
              'form[action*="/cart/add"] [name="id"]'
            );
        }

        /*
         * Some versions of the theme maintain
         * data-product-select separately.
         */
        if (!variantInput) {
          variantInput =
            section.querySelector(
              "[data-product-select]"
            );
        }

        if (!variantInput) {
          console.log(
            "Notification: variant input not found"
          );

          return null;
        }

        console.log(
          "Notification current variant ID:",
          variantInput.value
        );

        return variantInput.value;
      }

      updateCurrentVariant() {
        const variantId =
          this.getCurrentVariantId();

        if (!variantId) return;

        const variant =
          this.variants.find(
            (item) =>
              String(item.id) ===
              String(variantId)
          );

        if (!variant) {
          console.log(
            "Notification: variant not found:",
            variantId
          );

          return;
        }

        this.setVariant(variant);
      }

      setVariant(variant) {
        console.log(
          "NOTIFICATION CURRENT VARIANT:",
          variant
        );

        /*
         * Update displayed variant title.
         */
        if (this.variantTitle) {
          this.variantTitle.textContent =
            variant.title;

          if (
            variant.title === "Default Title"
          ) {
            this.variantTitle.classList.add(
              HIDDEN_CLASS
            );
          } else {
            this.variantTitle.classList.remove(
              HIDDEN_CLASS
            );
          }
        }

        /*
         * Update hidden form value sent to Shopify.
         */
        if (this.notificationProduct) {
          const productTitle =
            this.querySelector(
              ".product__notification__title"
            )
              ?.textContent
              ?.trim() || "";

          this.notificationProduct.value =
            productTitle +
            " - " +
            variant.title;
        }

        /*
         * Update data attribute.
         */
        if (this.notificationForm) {
          this.notificationForm.dataset.variantId =
            variant.id;
        }

        /*
         * IMPORTANT:
         * Also update actual form ID.
         *
         * Otherwise sessionStorage still remembers
         * the variant that was rendered by Liquid
         * when the page originally loaded.
         */
        if (
          this.notificationForm &&
          this.notificationFormBaseId
        ) {
          this.notificationForm.id =
            this.notificationFormBaseId +
            "--" +
            variant.id;
        }
      }

      checkState() {
        if (
          window.location.search.indexOf(
            "?contact_posted=true"
          ) !== -1
        ) {
          this.querySelector(
            NOTIFICATION_HEADING
          )?.classList.add(HIDDEN_CLASS);

          this.closest(
            POPUP_COMPONENT
          )?.classList.add(SUCCESS_CLASS);

          this.popup?.removeAttribute("inert");

          if (
            typeof this.popup?.showModal ===
            "function"
          ) {
            this.popup.showModal();
          } else {
            this.popup?.setAttribute(
              "open",
              ""
            );
          }
        }
      }

      notificationSubmitEvent(event) {
        if (!this.preventSubmit) return;

        event.preventDefault();

        /*
         * Final synchronization immediately
         * before submitting.
         */
        this.updateCurrentVariant();

        this.removeStorage();
        this.writeStorage();

        this.preventSubmit = false;

        this.notificationForm.submit();
      }

      writeStorage() {
        if (
          typeof window.sessionStorage !==
          "undefined"
        ) {
          window.sessionStorage.setItem(
            "notification_form_id",
            this.notificationForm.id
          );
        }
      }

      removeStorage() {
        window.sessionStorage.removeItem(
          "notification_form_id"
        );
      }

      disconnectedCallback() {
        if (this.popupObserver) {
          this.popupObserver.disconnect();
        }
      }
    }
  );
})();